"use client";

import { useState } from "react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { useWriterThreadsContext } from "./WriterThreadsContext";

interface WriterAddCommentProps {
  threadId: string;
  onCommentAdded?: () => void;
}

export const WriterAddComment = ({
  threadId,
  onCommentAdded,
}: WriterAddCommentProps) => {
  const { addComment } = useWriterThreadsContext();
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!comment.trim() || isSubmitting) return;

    setIsSubmitting(true);
    try {
      addComment(threadId, comment.trim());
      setComment("");
      onCommentAdded?.();
    } catch (error) {
      console.error("Failed to add comment:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="border-t border-gray-100 p-3">
      <div className="space-y-2">
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Add a comment..."
          className="min-h-[80px] resize-none text-sm"
          disabled={isSubmitting}
        />
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500">
            Press Cmd/Ctrl + Enter to submit
          </span>
          <Button
            type="submit"
            size="sm"
            disabled={!comment.trim() || isSubmitting}
            className="h-8"
          >
            {isSubmitting ? "Adding..." : "Add Comment"}
          </Button>
        </div>
      </div>
    </form>
  );
};
